import {
  IonAvatar,
  IonIcon,
  IonImg,
  IonModal,
  IonRow,
  IonSpinner,
} from "@ionic/react";
import DamageDefault from "../assets/image/damageDefault.png";
import { close, imageOutline } from "ionicons/icons";
import "./ViewDamageModal.css";
import { getMedia, useGetMediaQuery } from "../api/media";
import { useEffect, useState } from "react";
interface ViewDamageModalProps {
  damageModalIsOpen: boolean;
  setDamageModalIsOpen: (value: boolean) => void;
  damageType: string;
  damagePicture: string;
  vehiclePart: string;
  comment: string;
  damageId: string;
}

const ViewDamageModal: React.FC<ViewDamageModalProps> = ({
  damageModalIsOpen,
  setDamageModalIsOpen,
  damageType,
  damagePicture,
  vehiclePart,
  comment,
  damageId,
}) => {
  const [media, setMedia] = useState<string | null>();
  const [isLoading, setIsLoading] = useState<boolean>();

  useEffect(() => {
    const setMediaEffect = async () => {
      setIsLoading(true);
      if (damagePicture !== "") {
        setMedia((await getMedia({ id: damagePicture })) || null);
      } else {
        setMedia(null);
      }
      setIsLoading(false);
    };

    setMediaEffect();
  }, [damagePicture]);

  return (
    <IonModal
      isOpen={damageModalIsOpen}
      initialBreakpoint={1}
      breakpoints={[0, 1]}
      onDidDismiss={() => setDamageModalIsOpen(false)}
    >
      <div className="ViewDamageModal">
        <IonRow className="ion-align-items-center ion-justify-content-between ViewDamageModal-header">
          <div className="ViewDamageModal-title">{vehiclePart}</div>
          <IonIcon
            icon={close}
            className="ViewDamageModal-icon"
            onClick={() => setDamageModalIsOpen(false)}
          />
        </IonRow>
        <div>
          <IonAvatar className="ViewDamageModal-img">
            {!isLoading && (media || damagePicture) ? (
              <IonImg
                src={media || damagePicture}
                className="ViewDamageModal-img"
              />
            ) : !isLoading ? (
              <div className="ViewDamageModal-iconwrapper">
                <IonIcon
                  icon={imageOutline}
                  className="ViewDamageModal-img-icon"
                />
              </div>
            ) : (
              <IonSpinner name="crescent"></IonSpinner>
            )}
          </IonAvatar>
        </div>
        <IonRow className="ViewDamageModal-subtitle">{damageType}</IonRow>
        <IonRow className="ViewDamageModal-description">{comment}</IonRow>
      </div>
    </IonModal>
  );
};

export default ViewDamageModal;
